import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { ApiConstant, KeyConstant, LangConstant } from "const";
import { ApiUtils, HumpUtils, StorageUtils, SystemUtils } from "utils";

const EMPTY_ARRAY = [];

export default function useTotalUserList(enabled = true) {
  const { t: getLabel } = useTranslation();
  const branchId = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_ID);

  const query = useQuery({
    queryKey: [ApiConstant.REACT_QUERY_KEYS.getTotalUserList, branchId],
    enabled: Boolean(branchId) && Boolean(enabled),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    queryFn: async () => {
      const apiPayload = HumpUtils.decamelizeKeys({
        branchId,
        isIncludeUnit: true,
        isIncludeDepartment: true,
        isIncludePosition: true,
      });

      const response = await ApiUtils.createApiWithToken(false).get(ApiConstant.GET_LIST_USERS, apiPayload);
      const rawData = response.data?.data;
      let userList = [];
      if (Array.isArray(rawData)) {
        userList = rawData;
      } else if (rawData && typeof rawData === "object") {
        userList = rawData.list || rawData.data || rawData.users || [];
      }
      return HumpUtils.camelizeKeys(userList);
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  return {
    totalUsers: query.data || EMPTY_ARRAY,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
